import { AxiosInstance } from 'axios';
import apiUrl from '../apiUrl';
import {
  type LoadData,
  type LoadDataParams,
} from '../../../../types/isomorphic/load.types';

export class LoadService {
  #httpClient: AxiosInstance;
  baseUrl: string;

  constructor(httpClient: AxiosInstance) {
    this.#httpClient = httpClient;
    this.baseUrl = `${apiUrl}/load`;
  }

  getLoadData = (params: LoadDataParams): Promise<LoadData> => {
    const url = `${this.baseUrl}/load-data`;
    return this.#httpClient
      .get<LoadData>(url, { params })
      .then((response) => response.data);
  };
}

export default LoadService;
